import { gql } from '@biletiniz/apollo';

export const RUSSIA_VISA_BOOKING_INFO_QUERY = gql`
  query GetRussiaVisaBookingInfo($session: String!) {
    russiaVisaBookingInfo(session: $session) {
      providerContext {
        totalPrice
        currency
      }
      visaType
      passengers {
        givenName
        surname
        gender
        email
        telephone
        birthDate
        departureDate
        visaType
      }
      paymentCard {
        cardHolderName
        cardNumber
        cvc
        expireYear
        expireMonth
      }
    }
  }
`;
